module.exports = __webpack_public_path__ + "img/project_8.e223ef21.png";